import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon } from "../../../assets/close-icon";
import { LogoImg } from "../../../assets/logo";
import { MyAccountIcon } from "../../../assets/my-account-icon";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { useContext } from "react";
import styles from "./mobile-menu.module.css";
export var MobileMenu = function(param) {
    var handleMenuClose = param.handleMenuClose, children = param.children;
    var logicStore = useContext(SharedUiHeaderV2Context).logicStore;
    var handleTrackEvent = logicStore.handleTrackEvent;
    return /*#__PURE__*/ _jsx("nav", {
        children: /*#__PURE__*/ _jsxs("ul", {
            className: styles.mobileMenu,
            children: [
                /*#__PURE__*/ _jsx("li", {
                    className: styles.mobileLogo,
                    children: /*#__PURE__*/ _jsx("a", {
                        href: "/",
                        "aria-label": "cinch home page",
                        children: /*#__PURE__*/ _jsx(LogoImg, {})
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: styles.mobileProfileWrapper,
                    children: /*#__PURE__*/ _jsx("a", {
                        className: styles.mobileProfile,
                        href: "/my-profile",
                        "aria-label": "my profile mobile",
                        onClick: function() {
                            handleTrackEvent({
                                name: "click",
                                category: "mega menu",
                                label: "my profile",
                                action: "button"
                            });
                        },
                        children: /*#__PURE__*/ _jsx(MyAccountIcon, {})
                    })
                }),
                /*#__PURE__*/ _jsx("li", {
                    className: styles.closeIcon,
                    children: /*#__PURE__*/ _jsx("button", {
                        className: styles.mobileCloseButton,
                        "aria-label": "close icon",
                        onClick: handleMenuClose,
                        children: /*#__PURE__*/ _jsx(CloseIcon, {})
                    })
                }),
                children
            ]
        })
    });
};
